import UploadScript from "./UploadScript/UploadScript";
import OrderStageAccordion from "../../components/OrderStageAccordion";

import { useParams, useSearchParams } from "react-router-dom";
import {
  useGetRequestedActorDetailsQuery,
  useGetSelectedActorsQuery,
} from "@/redux/feature/orderManagement/actorSelection/actorSelectionApi";
import { useEffect, useState, useMemo } from "react";
import usePolling from "@/hooks/usePolling";
import useOrderVideoParams from "@/hooks/useOrderVideoParams";
import ProductShipping from "./ProductShipping/ProductShipping";
// import { useGetBackgroundQuery } from "@/redux/feature/orderManagement/background/backgroundApi";
import {
  RequiredPlanningStageActions,
  TOrderVideoStatus,
  TResponseOrderDetails,
} from "@/types/projectType";
import { useGetVideoScriptQuery } from "@/redux/feature/orderManagement/videoScript/videoScriptApi";

const PlanningStage = ({
  data,
  requiredActions,
  VideoStageStatus,
}: {
  VideoStageStatus: TOrderVideoStatus;

  requiredActions: RequiredPlanningStageActions[];
  data: TResponseOrderDetails;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { orderId, videoId } = useOrderVideoParams();
  const requiredActionsForCurrentVideo = requiredActions?.find(
    (item) => item?.videoId === videoId
  )?.adminRequiredActions?.required;

  const isUsingSameActorForAllVideos = data?.useSameActorForOthers;

  const isFeaturingProduct =
    data?.orderVideos?.find((item) => item.video_id === videoId)?.scriptDetails
      .primaryGoal?.id === "promotingProductorService";

  const isOverlayProduct = data?.orderVideos?.find(
    (item) => item.video_id === videoId
  )?.scriptDetails.isOverlayProduct;

  const actorVideoId = isUsingSameActorForAllVideos ? "1" : videoId;

  // Define polling templates
  const pollingTemplates = {
    script: [
      "client-script-revision-requested-001",
      "client-script-approved-001",
    ],
    requestMoreActor: ["admin-more-actors-requested-004"],
    selectedActor: ["admin-actors-submitted-002"],
  };

  // Create polling intervals
  const scriptPollingInterval = usePolling({
    templateIds: pollingTemplates.script,
  })?.pollingInterval;
  const requestedMoreActorPollingInterval = usePolling({
    templateIds: pollingTemplates?.requestMoreActor,
  }).pollingInterval;
  const selectedActorPollingInterval = usePolling({
    templateIds: pollingTemplates.selectedActor,
  }).pollingInterval;

  // Fetch data with polling intervals
  const { data: VideoScriptData, isLoading: isScriptLoading } =
    useGetVideoScriptQuery(
      { orderId, videoId },
      {
        skip: !isOpen,
        refetchOnMountOrArgChange: true,
        pollingInterval: scriptPollingInterval,
      }
    );

  const { data: SelectedActor } = useGetSelectedActorsQuery(
    { orderId, videoId: actorVideoId },
    {
      skip: !isOpen,
      refetchOnMountOrArgChange: true,
      pollingInterval: selectedActorPollingInterval,
    }
  );

  const { data: RequestedActorDetails } = useGetRequestedActorDetailsQuery(
    { orderId, videoId: actorVideoId },
    {
      skip: !isOpen || (SelectedActor?.data?.selectedActor?.length || 0) > 2,
      refetchOnMountOrArgChange: true,
      pollingInterval: requestedMoreActorPollingInterval,
    }
  );

  // Fetch background details
  // const { data: backgroundDetails } = useGetBackgroundQuery(
  //   { orderId, videoId },
  //   {
  //     skip: !isOpen,
  //     refetchOnMountOrArgChange: true,
  //   }
  // );
  useEffect(() => {
    if (VideoStageStatus?.stage_status?.planing_stage.inProgress) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [VideoStageStatus?.stage_status?.planing_stage.inProgress]);

  return (
    <OrderStageAccordion
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      isProgress={VideoStageStatus?.stage_status?.planing_stage.inProgress}
      title="Planning stage"
      stageNumber={1}
      initiallyOpen={VideoStageStatus?.stage_status?.planing_stage.inProgress}
      completed={VideoStageStatus?.stage_status?.planing_stage.completed}
    >
      <div className="mt-5">
        <div className="space-y-4 mb-5">
          {/* <UploadScript
            ActionsRequired={requiredActionsForCurrentVideo}
            scriptData={VideoScriptData?.data}
          /> */}

          {isFeaturingProduct && !isOverlayProduct && (
            <ProductShipping
              isActorAssigned={true}
              ActionsRequired={requiredActionsForCurrentVideo}
              scriptData={VideoScriptData?.data}
            />
          )}

          {/* {backgroundDetails?.data && (
            <BackgroundSelection backgroundDetails={backgroundDetails?.data} />
          )} */}
        </div>
      </div>
    </OrderStageAccordion>
  );
};

export default PlanningStage;
